import { FC } from 'react';
import { cn } from '../../utils/cn';
import { TimeSlotProps } from './types';

/**
 * Format time string to 12-hour format with AM/PM
 */
function formatTime(time: string): string {
  const parts = time.split(':');
  const hours = parts[0] || '00';
  const minutes = parts[1] || '00';
  const hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
}

export const TimeSlot: FC<TimeSlotProps> = ({ slot, isSelected, onClick }) => {
  const { startTime, endTime, isAvailable } = slot;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!isAvailable}
      aria-pressed={isSelected}
      aria-label={`${formatTime(startTime)} to ${formatTime(endTime)}${!isAvailable ? ', unavailable' : ''}`}
      className={cn(
        'px-3 py-2 text-sm font-medium rounded-lg border transition-all',
        'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-slate-900',
        // Selected state
        isSelected && 'bg-primary-600 text-white border-primary-600 hover:bg-primary-700',
        // Available but not selected
        !isSelected &&
          isAvailable &&
          'bg-white dark:bg-slate-800 text-gray-700 dark:text-slate-300 border-gray-200 dark:border-slate-700 hover:border-primary-300 dark:hover:border-primary-600 hover:bg-primary-50 dark:hover:bg-primary-900/20',
        // Unavailable
        !isAvailable && 'bg-gray-50 dark:bg-slate-800/50 text-gray-300 dark:text-slate-600 border-gray-100 dark:border-slate-700 cursor-not-allowed'
      )}
    >
      {formatTime(startTime)}
    </button>
  );
};

TimeSlot.displayName = 'TimeSlot';
